import styled from '@emotion/styled';
import { Breakpoints, Colors } from 'goalsetter-webapp-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 64px;
  width: 100%;
  max-width: 688px;
  padding-bottom: 24px;
  @media (max-width: ${Breakpoints.sm_portal}px) {
    width: 90%;
    padding-top: 16px;
  }
`;

export const titleStyle = (isMobile: boolean) => ({
  marginBottom: '32px',
});

export const lastInputStyle = (isMobile: boolean) => ({
  gridColumnStart: 1,
  gridColumnEnd: `span ${isMobile ? 1 : 2}`,
  marginBottom: '24px',
});

export const recaptchaStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  display: 'flex',
};

export const cardStyle = {
  width: '100%',
  marginTop: '32px',
};

export const titleWrapperStyle = { paddingTop: '64px' };

export const bottomTextStyle = { paddingTop: '24px' };

export const linkStyle = { color: Colors.BLUE_LIGHT, fontWeight: 'bold' };
